var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0665 3.2974C11.4665 3.88906 11.6998 4.5974 11.6998 5.36406C11.6915 7.36406 10.1165 8.98906 8.13314 9.05573C8.0498 9.0474 7.9498 9.0474 7.85814 9.05573C5.8748 8.98906 4.2998 7.36406 4.2998 5.36406C4.2998 3.3224 5.9498 1.66406 7.9998 1.66406",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1752 3.33594C15.7919 3.33594 17.0919 4.64427 17.0919 6.2526C17.0919 7.8276 15.8419 9.11094 14.2836 9.16927C14.2169 9.16094 14.1419 9.16094 14.0669 9.16927",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9666 12.1359C1.94993 13.4859 1.94993 15.6859 3.9666 17.0276C6.25827 18.5609 10.0166 18.5609 12.3083 17.0276C14.3249 15.6776 14.3249 13.4776 12.3083 12.1359C10.0249 10.6109 6.2666 10.6109 3.9666 12.1359Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7832 16.6641C16.3832 16.5391 16.9499 16.2974 17.4165 15.9391C18.7165 14.9641 18.7165 13.3557 17.4165 12.3807C16.9582 12.0307 16.3999 11.7974 15.8082 11.6641",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.cdad28018519988037af302ad0ef7080.svg";
export { ForwardRef as ReactComponent };